(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kg-pdp-med-assets"] && !Shopify.designMode) return;
  try {
    (()=>{
  'use strict';
  if(window.KgMedicalsPDP)return;
  function init(root){
    if(root.dataset.kgReady)return;
    root.dataset.kgReady='true';
    const cleanup=[];
    const on=(target,type,fn,options)=>{target.addEventListener(type,fn,options);cleanup.push(()=>target.removeEventListener(type,fn,options));};
  const page = {
    getElementById: id => root.querySelector('[data-km-id="'+id+'"], [id="'+id+'"]'),
    querySelector: selector => root.querySelector(selector.replace(/#([\w-]+)/g, '[data-km-id="$1"]')),
    querySelectorAll: selector => root.querySelectorAll(selector.replace(/#([\w-]+)/g, '[data-km-id="$1"]'))
  };
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  page.querySelectorAll('a[href^="#"]').forEach(link => {
    on(link,'click', event => {
      const anchor=decodeURIComponent(link.getAttribute('href').slice(1));const target = document.getElementById(anchor)||document.querySelector('[data-km-anchor="'+CSS.escape(anchor)+'"]');
      if (!target) return;
      event.preventDefault();
      let disclosure = target.closest('details');
      while (disclosure) {
        disclosure.open = true;
        disclosure = disclosure.parentElement.closest('details');
      }
      if (target.matches('.method-tabs button')) target.click();
      target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    });
  });

  const investmentForm = page.getElementById('investment-form');
  if (investmentForm) {
    const money = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 });
    const monthsFormat = new Intl.NumberFormat('es-CL', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    const numberFormat = new Intl.NumberFormat('es-CL');
    const readMoney = input => Number(input.value.replace(/[.\s$]/g, ''));
    const moneyInputs = [page.getElementById('roi-investment'), page.getElementById('roi-price')];
    moneyInputs.forEach(input => { const initial=readMoney(input);if(Number.isFinite(initial)&&initial>0)input.value=numberFormat.format(initial);
      on(input,'blur', () => { const value = readMoney(input); if (Number.isFinite(value) && value > 0) input.value = numberFormat.format(Math.round(value)); });
    });
    function updateInvestment() {
      const investment = readMoney(page.getElementById('roi-investment'));
      const price = readMoney(page.getElementById('roi-price'));
      const sessions = Number(page.getElementById('roi-sessions').value);
      const valid = [investment, price, sessions].every(value => Number.isFinite(value) && value > 0);
      const monthly = valid ? price * sessions : 0;
      const payback = valid ? investment / monthly : 0;
      page.getElementById('roi-months').textContent = valid ? monthsFormat.format(Math.ceil(payback * 10) / 10) : '—';
      page.getElementById('roi-unit').textContent = valid ? 'meses' : '';
      page.getElementById('roi-monthly').textContent = valid ? money.format(monthly) : '—';
      page.getElementById('roi-break-even').textContent = valid ? numberFormat.format(Math.ceil(investment / price)) : '—';
      page.getElementById('roi-status').textContent = !valid ? 'Completa los valores de tu centro.' : payback < 6 ? 'La facturación proyectada alcanza el valor del equipo en menos de seis meses.' : 'Plazo calculado con el precio y el volumen de sesiones de tu centro.';
    }
    on(investmentForm,'input', updateInvestment);
    on(investmentForm,'submit', event => event.preventDefault());
    updateInvestment();
  }
  function setupTabs(selector, onSelect) {
    const tabs = [...page.querySelectorAll(selector)];
    function select(index, focus = false) {
      tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        tab.classList.toggle('active', selected);
        page.getElementById(tab.getAttribute('aria-controls')).hidden = !selected;
        const symbol = tab.querySelector('.method-tab-symbol');
        if (symbol) symbol.textContent = selected ? '−' : '+';
      });
      if (onSelect) onSelect(tabs[index]);
      if (focus) tabs[index].focus();
    }
    tabs.forEach((tab, index) => {
      on(tab,'click', () => select(index));
      on(tab,'keydown', event => {
        const vertical = tab.parentElement.getAttribute('aria-orientation') === 'vertical';
        const nextKey = vertical ? 'ArrowDown' : 'ArrowRight';
        const previousKey = vertical ? 'ArrowUp' : 'ArrowLeft';
        let next;
        if (event.key === nextKey) next = (index + 1) % tabs.length;
        if (event.key === previousKey) next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); select(next, true); }
      });
    });
    if (tabs.length) {
      const initial = tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
      select(initial < 0 ? 0 : initial);
    }
  }
  const methodSteps = [...page.querySelectorAll('.method-tabs button')];
  function selectMethod(step) {
    methodSteps.forEach(button => {
      const active = button === step;
      button.setAttribute('aria-expanded', String(active));
      button.classList.toggle('active', active);
      button.querySelector('.method-tab-symbol').textContent = active ? '−' : '+';
      page.getElementById(button.getAttribute('aria-controls')).hidden = !active;
    });
    page.querySelectorAll('.method-visual').forEach(visual => {
      visual.hidden = visual.id !== 'visual-' + step.dataset.method;
    });
  }
  methodSteps.forEach(step => on(step,'click', () => {
    selectMethod(step);
  }));
  if (methodSteps.length) selectMethod(methodSteps.find(step => step.classList.contains('active')) || methodSteps[0]);

  setupTabs('.application-tabs [role="tab"]');
  setupTabs('.mode-tabs [role="tab"]');

  const hiemtLayout = page.querySelector('.hiemt-layout');
  if(hiemtLayout){
  // Slow explanatory shortening/relaxation cycle, not a device pulse frequency.
  const muscleFibers = [...hiemtLayout.querySelectorAll('.hiemt-contractile-fiber')];
  const muscleToggle = page.getElementById('hiemt-motion-toggle');
  const musclePhase = page.getElementById('hiemt-motion-phase');
  let musclePlaying = !reducedMotion;
  let muscleVisible = false;
  let muscleTimer = 0;
  let muscleElapsed = 0;
  let muscleLast = 0;
  function renderMuscle(amount) {
    const sx = 1 - .14 * amount;
    const sy = 1 / sx;
    muscleFibers.forEach(fiber => {
      const cy = Number(fiber.dataset.centerY) + 2;
      fiber.setAttribute('transform', `translate(320 ${cy}) scale(${sx.toFixed(4)} ${sy.toFixed(4)}) translate(-320 ${-cy})`);
    });
  }
  function muscleTick() {
    muscleTimer = 0;
    const now = performance.now();
    muscleElapsed += now - muscleLast;
    muscleLast = now;
    const phase = muscleElapsed % 4800;
    let amount = 0;
    let label = 'Relajación';
    if (phase >= 650 && phase < 2050) { amount = (1 - Math.cos(Math.PI * (phase - 650) / 1400)) / 2; label = 'Contracción'; }
    else if (phase >= 2050 && phase < 2650) { amount = 1; label = 'Contracción'; }
    else if (phase >= 2650 && phase < 4050) { amount = (1 + Math.cos(Math.PI * (phase - 2650) / 1400)) / 2; }
    renderMuscle(amount);
    if (musclePhase.textContent !== label) musclePhase.textContent = label;
    muscleTimer = window.setTimeout(muscleTick, 50);
  }
  function syncMuscleAnimation() {
    window.clearTimeout(muscleTimer);
    muscleTimer = 0;
    const active = hiemtLayout.dataset.hiemtStage === 'musculo';
    muscleToggle.textContent = musclePlaying ? 'Pausar animación' : 'Reproducir animación';
    muscleToggle.setAttribute('aria-label', (musclePlaying ? 'Pausar' : 'Reproducir') + ' animación de la contracción muscular');
    if (!active) { muscleElapsed = 0; renderMuscle(0); musclePhase.textContent = 'Relajación'; }
    if (active && musclePlaying && muscleVisible && !document.hidden) {
      muscleLast = performance.now();
      muscleTimer = window.setTimeout(muscleTick, 50);
    }
  }
  on(muscleToggle,'click', () => { musclePlaying = !musclePlaying; syncMuscleAnimation(); });
  on(document,'visibilitychange', syncMuscleAnimation);
  const muscleObserver = new IntersectionObserver(entries => {
    muscleVisible = entries[0].isIntersecting;
    syncMuscleAnimation();
  });
  muscleObserver.observe(hiemtLayout.querySelector('.hiemt-visual'));
  const hiemtDescriptions = {
    campo: ['01', 'El campo atraviesa los tejidos hasta alcanzar la zona de estimulación.'],
    neurona: ['02', 'Las neuronas motoras transmiten la señal a las fibras musculares.'],
    musculo: ['03', 'Las fibras se contraen y desarrollan tensión en el grupo muscular seleccionado.']
  };
  setupTabs('.hiemt-stage-tabs [role="tab"]', tab => {
    const stage = tab.dataset.stage;
    hiemtLayout.dataset.hiemtStage = stage;
    syncMuscleAnimation();
    const status = page.getElementById('hiemt-status');
    status.querySelector('.hiemt-status-index').textContent = hiemtDescriptions[stage][0];
    status.querySelector('span:last-child').textContent = hiemtDescriptions[stage][1];
  });


  cleanup.push(()=>{clearTimeout(muscleTimer);muscleObserver.disconnect();});
  }
  // Qualitative conceptual comparison, without measured Prosculpt force values.
  const supraFigure = page.querySelector('.supramaximal-demo');
  if(supraFigure){
  const supraReveal = page.getElementById('supra-curve-reveal');
  const supraMarker = page.getElementById('supra-time-marker');
  const supraPhase = page.getElementById('supra-phase');
  const supraExplanation = page.getElementById('supra-explanation');
  const supraToggle = page.getElementById('supra-toggle');
  let supraPlaying = !reducedMotion;
  let supraVisible = false;
  let supraTimer = 0;
  let supraElapsed = reducedMotion ? 7000 : 0;
  let supraLast = 0;
  function renderSupramaximal(time) {
    const phase = time % 10000;
    const progress = Math.min(phase / 7000, 1);
    const cursor = 56 + 550 * progress;
    supraReveal.setAttribute('width', String(1 + 554 * progress));
    supraMarker.setAttribute('x1', cursor.toFixed(2));
    supraMarker.setAttribute('x2', cursor.toFixed(2));
    let label = 'Desarrollo de tensión';
    let description = 'Ambas curvas muestran el desarrollo de tensión durante la contracción.';
    if (progress >= .3 && progress < .72) {
      label = 'Referencia voluntaria máxima';
      description = 'En este esquema, la respuesta supramáxima supera la referencia de contracción voluntaria máxima.';
    } else if (progress >= .72 && progress < 1) {
      label = 'Relajación';
      description = 'La tensión disminuye al finalizar la contracción.';
    } else if (progress >= 1) {
      label = 'Comparación completa';
      description = 'La línea discontinua permite identificar qué significa superar la referencia voluntaria máxima.';
    }
    if (supraPhase.textContent !== label) {
      supraPhase.textContent = label;
      supraExplanation.textContent = description;
    }
  }
  function supraTick() {
    supraTimer = 0;
    const now = performance.now();
    supraElapsed += now - supraLast;
    supraLast = now;
    renderSupramaximal(supraElapsed);
    supraTimer = window.setTimeout(supraTick, 50);
  }
  function syncSupramaximal() {
    window.clearTimeout(supraTimer);
    supraTimer = 0;
    supraToggle.textContent = supraPlaying ? 'Pausar animación' : 'Reproducir animación';
    supraToggle.setAttribute('aria-label', (supraPlaying ? 'Pausar' : 'Reproducir') + ' gráfico comparativo de contracciones');
    if (supraPlaying && supraVisible && !document.hidden) {
      supraLast = performance.now();
      supraTimer = window.setTimeout(supraTick, 50);
    }
  }
  on(supraToggle,'click', () => { supraPlaying = !supraPlaying; syncSupramaximal(); });
  on(document,'visibilitychange', syncSupramaximal);
  const supraObserver = new IntersectionObserver(entries => {
    supraVisible = entries[0].isIntersecting;
    syncSupramaximal();
  });
  renderSupramaximal(supraElapsed);
  supraObserver.observe(supraFigure);

  cleanup.push(()=>{clearTimeout(supraTimer);supraObserver.disconnect();});
  }
  const gallery = page.getElementById('results-gallery');
  if(gallery && gallery.querySelector('.result-card')){
  const cards = [...gallery.querySelectorAll('.result-card')];
  const previous = page.getElementById('results-previous');
  const next = page.getElementById('results-next');
  const position = page.getElementById('results-position');
  function updateGallery() {
    const gap = parseFloat(getComputedStyle(gallery).gap) || 0;
    const step = cards[0].getBoundingClientRect().width + gap;
    const index = Math.min(cards.length - 1, Math.round(gallery.scrollLeft / step));
    const style = getComputedStyle(gallery);
    const contentWidth = gallery.clientWidth - parseFloat(style.paddingLeft || 0) - parseFloat(style.paddingRight || 0);
    const visibleCount = Math.max(1, Math.floor((contentWidth + gap) / step + 0.01));
    const lastVisible = Math.min(cards.length, index + visibleCount);
    const range = visibleCount > 1 ? `${String(index + 1).padStart(2, '0')}–${String(lastVisible).padStart(2, '0')}` : String(index + 1).padStart(2, '0');
    position.textContent = `${range} / ${String(cards.length).padStart(2, '0')}`;
    previous.disabled = gallery.scrollLeft < 4;
    next.disabled = gallery.scrollLeft >= gallery.scrollWidth - gallery.clientWidth - 4;
  }
  function moveGallery(direction) {
    const gap = parseFloat(getComputedStyle(gallery).gap) || 0;
    gallery.scrollBy({ left: (cards[0].getBoundingClientRect().width + gap) * direction, behavior: reducedMotion ? 'auto' : 'smooth' });
  }
  on(previous,'click', () => moveGallery(-1));
  on(next,'click', () => moveGallery(1));
  on(gallery,'scroll', updateGallery, { passive: true });
  on(window,'resize', updateGallery);
  updateGallery();
  if('ResizeObserver' in window){const sizeObserver=new ResizeObserver(updateGallery);sizeObserver.observe(gallery);cards.forEach(card=>sizeObserver.observe(card));cleanup.push(()=>sizeObserver.disconnect());}
  gallery.querySelectorAll('img').forEach(img=>on(img,'load',updateGallery));

  }
  const content = page.getElementById('contenido');
  content.querySelectorAll('details').forEach(detail => { detail.open = false; });
  content.querySelectorAll('[data-km-id="investment-form"] input').forEach(input => { input.readOnly = false; });
  const scenarioLabel=content.querySelector('.scenario-label');if(scenarioLabel)scenarioLabel.textContent='ESCENARIO EDITABLE';
  content.classList.add('pdp-interactive');


  // A product without a selected Shopify video falls back to the editable image.
  const media=page.getElementById('benefits-media');
  if(media){
    const film=media.querySelector('video');
    const videoOption=media.querySelector('[data-media-option="video"]');
    const imageOption=media.querySelector('[data-media-option="image"]');
    const showVideo=media.dataset.mediaType==='video'&&!!film;
    if(imageOption)imageOption.hidden=showVideo;
    if(videoOption)videoOption.hidden=!showVideo;
    const play=media.querySelector('.pdp-film-play');
    if(film&&play){
      on(play,'click',()=>{film.play().catch(()=>{play.hidden=false;});});
      on(film,'play',()=>{play.hidden=true;});
      on(film,'pause',()=>{play.hidden=false;});
      on(film,'ended',()=>{play.hidden=false;});
      cleanup.push(()=>film.pause());
    }
  }
  const mobile=matchMedia('(max-width:640px)');
  const details=[...page.querySelectorAll('.v2-detail')];
  function updateMobile(){
    details.forEach((detail,index)=>{
      detail.open=!mobile.matches||(detail.classList.contains('v2-benefit')&&index===0);
      const summary=detail.querySelector('summary');if(summary)summary.tabIndex=mobile.matches?0:-1;
    });
    const supra=page.getElementById('supra-mobile-detail');if(supra)supra.open=!mobile.matches;
  }
  updateMobile();on(mobile,'change',updateMobile);
  const equipment=page.getElementById('detalles-equipo');
  if(equipment){
    const tabs=[...equipment.querySelectorAll('[role="tab"]')];
    function selectEquipment(tab,focus=false){tabs.forEach(item=>{const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;const panel=page.getElementById(item.getAttribute('aria-controls'));if(panel)panel.hidden=!selected;});if(focus)tab.focus();}
    tabs.forEach((tab,index)=>{on(tab,'click',()=>selectEquipment(tab));on(tab,'keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%tabs.length;if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;if(event.key==='Home')next=0;if(event.key==='End')next=tabs.length-1;if(next!==undefined){event.preventDefault();selectEquipment(tabs[next],true);}});});
  }
  // Hide menu destinations when their corresponding block is removed in the editor.

  root.__kgDestroy=()=>{cleanup.forEach(fn=>fn());delete root.dataset.kgReady;};

  }
  function syncNavigation(){
    document.querySelectorAll('[data-km-section="navigation"] .nav-links a').forEach(link=>{
      if(!link.hash)return;
      const anchor=decodeURIComponent(link.hash.slice(1));const target=document.getElementById(anchor)||document.querySelector('[data-km-anchor="'+CSS.escape(anchor)+'"]');
      link.hidden=!target;
    });
  }
  const mount=()=>{document.querySelectorAll('[data-km-section]').forEach(init);syncNavigation();};
  window.KgMedicalsPDP={mount};
  document.addEventListener('shopify:section:load',mount);
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-km-section]').forEach(root=>root.__kgDestroy?.()));
  document.addEventListener('shopify:block:select',event=>{const block=event.target.closest('[data-km-block]')||event.target;if(!block)return;const root=block.closest('[data-km-section]');if(root){const panel=block.closest('[role="tabpanel"]');if(panel){const tab=root.querySelector('[aria-controls="'+panel.id+'"]');if(tab)tab.click();}if(block.matches('[role="tab"]'))block.click();}block.querySelectorAll('details').forEach(d=>d.open=true);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
})();
  } catch(e) { console.error(e); }
})();

})();
